import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function KeywordsAdmin({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Clients keywords'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

